export default "__VITE_ASSET__FZVJ9AP3__"